<template>

<h2 class="text-bold page-title">
    {{ getMessageByLang('suppliersText', 'Поставщики') }}
</h2>

  <Grid ref="grid" :data-items="gridData" :edit-field="'inEdit'" :sortable="true"
    :sort="sort" :pageable="pageable" :take="take" :skip="skip" :total="total" :loader="loader"
    @datastatechange="dataStateChange" :columns="columns">

    <template v-slot:status="{ props }">
      <td class="k-command-cell k-table-td"> 
        {{ getStatus(props.dataItem.status) }}
      </td>
    </template>

    <template v-slot:operation="{ props }">
      <td class="k-command-cell k-table-td">
        <div class="cell-control">
          <Button :theme-color="'primary'" class="k-grid-edit-command" @click="edit(props.dataItem)"
            :svg-icon="pencilIcon" />
          <Button class="k-grid-remove-command" @click="showModalDelete(props.dataItem)" :svg-icon="trashIcon" />
        </div>
      </td>
    </template>

    <GridToolbar>
      <Button title="Add new" :theme-color="'primary'" @click='create'>
        {{ addText }}
      </Button>
    </GridToolbar>
    <GridNoRecords>Нет данных</GridNoRecords>
  </Grid>

  <Dialog v-if="itemInCreate" :data-item="itemInCreate" :width="600" @save="createSupplier" @cancel="cancel">
    <h3 class="supplier-modal-title">{{  supplierText  }}</h3>

    <Form ref="supplierFormCreate" @submit="handleCreateSubmit" :initial-values="itemInCreate" @change="handleFormChangeCreate" :ignore-modified="false"
    :validator="validator">
      <SupplierForm :supplierItem="itemInCreate" :onUpdateUserId="handleUpdateUserId" propType="create" />
    </Form>

    <div class="supplier-modal-footer">
      <Button @click="cancel">{{ closeText }}</Button>
      <Button :theme-color="'primary'" @click="createSupplier">{{ saveText }}</Button>
    </div>
  </Dialog>

  <Dialog v-if="itemInEdit" :data-item="itemInEdit" :width="600" @save="updateSupplier" @cancel="cancel">
    <h3 class="supplier-modal-title">{{ supplierText }}</h3>
    <Form ref="supplierFormUpdate" @submit="handleUpdateSubmit" :initial-values="itemInEdit" :ignoreModified="true" @change="handleFormChangeCreate">
      <SupplierForm :supplierItem="itemInEdit" :onUpdateUserId="handleUpdateUserId" propType="edit" />
    </Form>

    <div class="supplier-modal-footer">
      <Button @click="cancel">{{  closeText }}</Button>
      <Button :theme-color="'primary'" @click="updateSupplier">{{  saveText  }}</Button>
    </div>
  </Dialog>

  <ModalDelete v-if="isShowModalDelete" @accept="modalDeleteAccept" @cancel="modalDeleteCancel" />
</template>

<script>
import { Grid, GridToolbar, GridNoRecords } from '@progress/kendo-vue-grid';
import { Form } from "@progress/kendo-vue-form";
import { Button } from '@progress/kendo-vue-buttons';
import { Dialog } from '@progress/kendo-vue-dialogs';
import { cancelIcon, saveIcon } from '@progress/kendo-svg-icons';
import { dataString } from '../../composables/dataString';
import { pencilIcon, trashIcon } from '@progress/kendo-svg-icons';
import { provideLocalizationService } from "@progress/kendo-vue-intl";
import SupplierForm from '@/components/forms/SupplierForm.vue';
import axios from "axios";
import { getMessageByLang } from '@/utils/translate.js';
import { addListener,  removeListener } from '@/utils/app';
import ModalDelete from "@/components/modals/ModalDelete.vue";

export default {
  components: {
    ModalDelete,
    Grid,
    GridToolbar,
    GridNoRecords,
    Button,
    Dialog,
    Form,
    SupplierForm
  },
  data: function () {
    return {
      itemOfCreate: {},
      createItemData: {},
      cancelIcon, saveIcon,
      filter: null,
      sort: null,
      pageable: true,
      gridData: [],
      skip: 0,
      take: 10,
      total: 0,
      updatedData: [],
      editID: null,
      loader: false,
      itemInCreate: false,
      itemInEdit: false,
      pencilIcon,
      trashIcon,
      statuses: [
        {id: 'active', name: this.getStatusText('statusActive')},
        {id: 'inactive', name: this.getStatusText('statusUnactive')},
        {id: 'suspended', name: this.getStatusText('statusActiveStop')}
      ],
      getMessageByLang : getMessageByLang,
      isShowModalDelete: false,
      deleteItem: null
    };
  },
  inject: {
		kendoLocalizationService: { default: null },
	},
  computed: {
    columns() {
      return [
        { field: 'id', width: 60, title: 'ID' },
        { field: 'name', title: getMessageByLang('supplierNameText', 'Название поставщика')},
        { field: 'status', title: getMessageByLang('supplierStatus', 'Статус поставщика'), cell: 'status' },
        { cell: 'operation', filterable: false, width: '150px' },
      ]
    },
    addText() {
      return provideLocalizationService(this).toLanguageString(
        'addText',
        'addText'
      );
    },
    supplierText() {
      return provideLocalizationService(this).toLanguageString(
        'supplier',
        'supplier'
      );
    },
    closeText() {
      return provideLocalizationService(this).toLanguageString(
        'closeText',
        'closeText'
      );
    },
    saveText() {
      return provideLocalizationService(this).toLanguageString(
        'btnSave',
        'btnSave'
      );
    },
    dataState() {
      return {
        sort: this.sort,
        skip: this.skip,
        take: this.take,
      };
    },
  },

  created: function () {
    this.getData();
    addListener(this.addEscListener)
  },

  methods: {
    addEscListener(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.isShowModalDelete = false;
        this.itemInCreate = undefined;
        this.itemInEdit = undefined;
      }
    },

    showModalDelete(item) {
      this.deleteItem = item;
      this.isShowModalDelete = true;
    },

    modalDeleteAccept() {
      this.remove(this.deleteItem);
    },

    modalDeleteCancel() {
      this.isShowModalDelete = false;
    },

    validator(event) {
        this.itemInCreate = {
          ...this.itemInCreate,
          ...event
        };
        this.itemOfCreate = {
          ...event
        };
    },
    getStatusText(status) {
      return provideLocalizationService(this).toLanguageString(
        status,
        status
      );
    },

    handleUpdateUserId(type, val) {
      if(type === 'edit') {
        this.itemInEdit.user_id = val;
      } else {
        this.itemInCreate.user_id = val;
      }
    },

    getStatus(item) {
      let val = '-';

      for(let status of this.statuses) {
        if(status.id === item) {
          val = status.name;
        }
      }

      return val;
    },

    create() {
      this.itemInCreate = {};
    },
    edit(dataItem) {
      this.itemInEdit = this.cloneProduct(dataItem);
    },
    remove(dataItem) {
      var self = this;
      axios.delete('/api/v1/suppliers/' + dataItem.id)
        .then(res => {
          if (res.data) {
            if (res.data.message) {
              self.isShowModalDelete = false;
              self.getData();
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response);
          }
        });
    },
    cloneProduct(item) {
      return Object.assign({}, item);
    },
    cancel() {
      this.itemInEdit = undefined;
      this.itemInCreate = undefined;
    },
    getData: function () {
      const that = this;
      this.loader = true;

      this.dataState.take = 20;

      axios.get('/api/v1/suppliers?' + dataString(this.dataState))
        .then(res => {
          if (res.data) {
            if (res.data.message) {
              that.total = res.data.total;
              that.updatedData = [...res.data.data];
              that.gridData = res.data.data.map((item) => {
                item.user_id = item?.user?.id || null;
                return item;
              });

              this.loader = false;
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.data.message) {
              // $toast.error(error.response.data.message);
            }
          } else if (error.request) {
            console.log(error.request);
          }
        });
    },
    handleFormChangeCreate(event) {
      this.itemInCreate = {
        ...this.itemInCreate,
        ...event.value
      }
    },
    createSupplier: function () {
      this.handleCreateSubmit(this.itemInCreate);
    },
    handleCreateSubmit(dataItem) {
      dataItem.user_id = this.itemInCreate.user_id;

      if(!dataItem.user_id || !dataItem.contact_info || !dataItem.name || !dataItem.status) return

      const formValues = JSON.stringify(dataItem, null, 2);

      var self = this;
      axios.post('/api/v1/suppliers/', formValues)
        .then(function () {
          self.itemInCreate = undefined;
          self.getData();
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.data.errors) {
              self.$refs.supplierFormCreate.form.errors.VALIDATION_SUMMARY = error.response.data.message;
              for (let key in error.response.data.errors) {
                self.$refs.supplierFormCreate.form.errors[key] = error.response.data.errors[key][0];
              }
            } else {
              if (error.response.data.message) {
                self.$refs.supplierFormCreate.form.errors.VALIDATION_SUMMARY = error.response.data.message;
              }
            }
          } else if (error.request) {
            console.log(error.request);
          }
        });
    },
    updateSupplier: function () {
      this.$refs.supplierFormUpdate.onSubmit();
    },
    handleUpdateSubmit(dataItem) {
      dataItem.user_id = dataItem?.user?.id || null;
      dataItem.email = dataItem.email === null ? '' : dataItem.email;

      if(!dataItem.user_id || !dataItem.contact_info || !dataItem.name || !dataItem.status) return

      const formValues = JSON.stringify(dataItem, null, 2);
      var self = this;
      
      axios.put('/api/v1/suppliers/' + dataItem.id, formValues)
        .then(function () {
          self.itemInEdit = undefined;
          self.getData();
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.data.errors) {
              self.$refs.supplierFormUpdate.form.errors.VALIDATION_SUMMARY = error.response.data.message;
              for (let key in error.response.data.errors) {
                self.$refs.supplierFormUpdate.form.errors[key] = error.response.data.errors[key][0];
              }
            } else {
              if (error.response.data.message) {
                self.$refs.supplierFormUpdate.form.errors.VALIDATION_SUMMARY = error.response.data.message;
              }
            }
          } else if (error.request) {
            console.log(error.request);
          }
        });
    },
    createAppState: function (dataState) {
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.filter = dataState.filter;
      this.sort = dataState.sort;
      this.getData();
    },
    dataStateChange: function (event) {
      this.createAppState(event.data);
    },
  },

  unmounted() {
    removeListener(this.addEscListener)
  }
};
</script>

<style lang="scss">
.supplier-modal-title {
  font-size: 24px;
  margin-bottom: 1rem;
}

.supplier-modal-footer {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem
}
</style>
